import { UserRoundCheck } from "lucide-react";

import { useAuth } from "@/hooks/useAuth";
import { isImpersonating, stopImpersonation } from "@/lib/api";

import { Button } from "./ui/button";

/**
 * Orange strip shown at the top when a superadmin is acting as another user.
 * One button returns them to their original session. No-op for everyone else.
 */
export function ImpersonationBanner() {
  const { email } = useAuth();
  if (!isImpersonating()) return null;

  return (
    <div className="flex flex-wrap items-center justify-between gap-2 border-b border-amber-400/40 bg-amber-400/10 px-3 py-2 text-sm text-amber-700 dark:bg-amber-500/15 dark:text-amber-300 sm:gap-3 sm:px-4">
      <div className="flex min-w-0 items-center gap-2">
        <UserRoundCheck className="h-4 w-4 shrink-0" />
        <span className="truncate">
          Ты зашёл как <span className="font-semibold">{email}</span>
          <span className="hidden sm:inline">. Видишь и делаешь то же, что и он.</span>
        </span>
      </div>
      <Button
        size="sm"
        variant="outline"
        className="shrink-0 border-amber-400/50 bg-transparent hover:bg-amber-400/20"
        onClick={() => {
          stopImpersonation();
          window.location.href = "/cabinet/admin-panel/users";
        }}
      >
        Выйти
      </Button>
    </div>
  );
}
